import { BenefitType } from '@epi-constants/benefitTypes';
import { IBenefitGroupSettings } from '@epi-models/pages/Beneficiaries';
import { IBenefitMaxAmounts } from '@epi-models/pages/BenefitGroups';

import { BenefitGroupSettingsState } from './benefitGroupSettings.slice';

const selectBenefitGroupSettingsState = (state): BenefitGroupSettingsState =>
  state.benefitGroupSettings;

export function getBenefitSelected(
  state,
  benefitTypeId?: string
): IBenefitGroupSettings | undefined {
  return selectBenefitGroupSettingsState(state).benefitGroupSettings?.find(
    b => b.benefitType.toLowerCase() === benefitTypeId
  );
}

const getMaxAmountByBenefit = (
  settings: IBenefitGroupSettings[],
  benefitType: string
) =>
  settings?.find(x => x.benefitType.toLowerCase() === benefitType)
    ?.maxAmountPerPeriod ?? 0;

export const getBenefitMaxAmounts = (
  settings?: IBenefitGroupSettings[]
): IBenefitMaxAmounts | undefined => {
  if (!settings) return undefined;
  return {
    Lunch: getMaxAmountByBenefit(settings, BenefitType.Lunch),
    Recreational: getMaxAmountByBenefit(settings, BenefitType.Recreational),
    Massage: getMaxAmountByBenefit(settings, BenefitType.Massage),
    Wellbeing: getMaxAmountByBenefit(settings, BenefitType.Wellbeing),
    Transport: getMaxAmountByBenefit(settings, BenefitType.Transport)
  };
};

export const selectActiveBenefits = (state): string[] =>
  selectBenefitGroupSettingsState(state).activeBenefits;

export const selectIsActiveBenefitsLoaded = (state): boolean =>
  selectBenefitGroupSettingsState(state).isActiveBenefitsLoaded;

export const selectIsOrderInProcess = (state): boolean =>
  selectBenefitGroupSettingsState(state).isOrderInProgress;

export const selectGoToPageLink = (state): string =>
  selectBenefitGroupSettingsState(state).goToPageLink;
